import React from 'react'
import Chronology from '../../components/chronology'

const HistoryIndex = (props) => (
  <Chronology {...props} index />
)

export default HistoryIndex
